import { _ } from "~/i18n";
import { MAX_TITLE_LEN } from "../dialogs/const";
import { createMyMapsInput } from "./input";
import { node } from "~/util/dom";
import MyMapsFolders from "./folders";

interface IState {
	folderId: string;
	folderTitle: string;
	newFolderTitle: string;
	createNewFolder: boolean;
}

interface IFolder {
	id: string;
	title: string;
}

interface IOpts {
	disabled?: boolean;
	folder?: IFolder;
	isTrackLink?: boolean;
	selectFirstFolder?: boolean;
	moveFolders?: Array<IFolder>;
	onChange?: (state: IState) => void;
}

export default class MyMapsFolderSelectCreate {
	_container: HTMLDivElement;

	_state: IState;

	_origState: IState;

	_opts: IOpts;

	_createFolderCont: HTMLDivElement;

	_mymapsFolders: MyMapsFolders;

	constructor(opts: IOpts) {
		this._opts = {
			disabled: false,
			folder: null,
			isTrackLink: false,
			moveFolders: [],
			selectFirstFolder: false,
			onChange: () => {},
			...opts,
		};
		this._state = {
			folderId: this._opts.folder ? this._opts.folder.id : "",
			folderTitle: this._opts.folder ? this._opts.folder.title : "",
			newFolderTitle: "",
			createNewFolder: false,
		};
		this._origState = {
			...this._state,
		};
		this._mymapsFolders = null;

		this._build();
	}

	get container() {
		return this._container;
	}

	get state() {
		const state = {
			...this._state,
		};

		state.folderTitle = state.newFolderTitle.trim() || state.folderTitle || _("detail.content.mymapsplace.saved2");

		return state;
	}

	get changed() {
		return this._state.folderId !== this._origState.folderId
			|| this._state.newFolderTitle !== "";
	}

	set moveFolders(moveFolders: IOpts["moveFolders"]) {
		this._mymapsFolders.moveFolders = moveFolders;
	}

	overwriteOrigState(folderId: string) {
		// napr. v jednom kroku jsme vytvorili slozku
		this._state.folderId = folderId;
		this._state.newFolderTitle = "";
		this._state.createNewFolder = false;

		this._createFolderCont.remove();

		this._origState = {
			...this._state,
		};

		this._opts.onChange(this._state);
	}

	_build() {
		const container = node("div", { className: "mymapsFolderSelectCreate" });
		// ulozit do slozky, nejde vzdy videt
		const createFolder = createMyMapsInput({
			placeholder: _("note.nameFolder"),
			onChange: newFolder => {
				this._state.newFolderTitle = newFolder;
			},
			text: "",
			count: MAX_TITLE_LEN,
		});

		// slozka
		this._mymapsFolders = new MyMapsFolders({
			folder: this._opts.folder,
			disabled: this._opts.disabled,
			moveFolders: this._opts.moveFolders,
			isTrackLink: this._opts.isTrackLink,
			selectFirstFolder: this._opts.selectFirstFolder,
			onSelect: (type, selectData) => {
				switch (type) {
					case "folder":
						this._state.folderId = selectData.id;
						this._state.folderTitle = selectData.title;
						this._state.newFolderTitle = "";
						this._state.createNewFolder = false;

						createFolder.container.remove();
						createFolder.input.value = "";

						this._opts.onChange(this._state);
						break;

					case "different-folder":
						this._state.folderId = "";
						this._state.folderTitle = "";
						this._state.createNewFolder = true;

						container.before(createFolder.container);

						this._opts.onChange(this._state);
						break;

					case "places":
						this._state.folderId = "";
						this._state.folderTitle = "";
						this._state.newFolderTitle = "";
						this._state.createNewFolder = false;

						createFolder.container.remove();
						createFolder.input.value = "";

						this._opts.onChange(this._state);
						break;

					default:
				}
			},
		});

		container.append(this._mymapsFolders.container);

		this._container = container;
		this._createFolderCont = createFolder.container;
	}
}
